import { render } from "./rejectPromote.vue?vue&type=template&id=83042bda&scoped=true"
import script from "./rejectPromote.vue?vue&type=script&lang=js"
export * from "./rejectPromote.vue?vue&type=script&lang=js"

import "./rejectPromote.vue?vue&type=style&index=0&id=83042bda&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83042bda"]])

export default __exports__